export const SHOW_COLUMN_DELAY = 400;
export const CONTAINER_REMOVE_DELAY = 520;
export const CONTAINER_REMOVE_ANIMATION_TIME = 250;
export const VISIBILITY_ANIMATION_REMOVE_DELAY =
  CONTAINER_REMOVE_DELAY + CONTAINER_REMOVE_ANIMATION_TIME;
